<template>
    <div>
        <b-overlay :show="loading" rounded="sm">
            <b-row>
                <b-col cols="12" class="text-end">
                    <b-button @click="addType">{{ $translate('add_process') }}</b-button>
                </b-col>
            </b-row>
            <b-modal v-model="itemModal" id="item-modal" header-class="p-0"
                footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap form-sample"
                @ok="saveTemplateType" @cancel="cancel" @close="cancel">
                <template #modal-title="{ cancel }">
                    <div class="title-block text-center p-2">
                        {{ `${(model.id ? $translate('edit') : $translate('add'))} ${$translate('type')}` }}
                    </div>
                    <div class="close-btn" @click="cancel()">x</div>
                </template>
                <!-- <b-overlay :show="loading" rounded="sm"> -->
                    <b-form bg-variant="light">
                        <b-col cols="12">
                            <label for="input-sequence_no" class="mb-3"><strong>{{ $translate('sequence_no') }}<span
                                class="red">*</span></strong></label>
                            <b-form-input type="number" id="input-sequence_no" required v-model="model.sequence_no"
                                placeholder="Sequence Number" inputmode="numeric" trim></b-form-input>
                        </b-col>
                        <b-col cols="12" class="mt-3 dd">
                            <label for="input-checkoff_type_id" class="mb-3"><strong>{{ $translate('review_type')
                            }}<span
                            class="red">*</span></strong></label>
                            <b-form-select id="input-checkoff_type_id" class="form-control" v-model="model.checkoff_type_id" @change="type => setUsersForNotification(type)"
                                :options="types" text-field="name" value-field="id" required trim>
                                <template #first>
                                    <b-form-select-option :value="null" disabled>{{ $translate('select_the_review_type')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" class="mt-3 dd">
                            <label for="input-notify_users" class="mb-3"><strong>{{ $translate('users_for_notification')
                            }}</strong></label>
                            <multiselect id="input-notify_users" :placeholder="$translate('select_the_users_for_notification')" 
                            v-model="model.notify_users" 
                            :options="userOptions" 
                            :searchable="true"
                            :deselectLabel="deselectLabel" 
                            :selectedLabel="selectedLabel" 
                            :multiple="true" 
                            :preserve-search="true"
                            :selectLabel="selectLabel" 
                            @remove="selectedRoles"
                            @select="selectedRoles"
                            :disabled="model.notify_roles && model.notify_roles.length > 0"
                            label="name" track-by="id" :close-on-select="false">
                                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></template>
                            </multiselect>
                        </b-col>
                        <b-col cols="12" class="mt-3 dd">
                            <b-form-checkbox-group
                            v-model="model.notify_roles"
                            :options="notifyUserRolesoptions"
                            class="mb-3"
                            value-field="item"
                            text-field="name"
                            ></b-form-checkbox-group>
                        </b-col>
                    </b-form>
                    <template #modal-footer="{ ok, cancel }">
                        <b-button variant="info" size="fw" @click="ok()">
                            {{
                                `${!!model.index || !!model.id
                                    ? $translate('update')
                                    : $translate('create')
                                    } ${$translate('type')}`
                            }}
                        </b-button>
                        <b-button size="fw" v-if="!!model.id || !!model.index" variant="delete-button"
                            @click="deleteTemplateType()">
                            {{ $deleteLabel() }}
                        </b-button>
                        <b-button size="fw" variant="info" @click="cancel()">
                            {{ $cancelLabel() }}
                        </b-button>
                    </template>
                <!-- </b-overlay> -->
            </b-modal>

            <b-table responsive :items="templateTypes" :fields="itemFields">
                <template #cell(id)="{ value }">
                    <b-button variant="pink-button" @click="viewType(value)" class="mr-2">
                        <img src="@/assets/images/icon/view.svg">
                    </b-button>
                </template>
            </b-table>
        </b-overlay>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import popupMixins from '@/mixins/popupMixins'

export default {
    props: ['template'],
    mixins: [popupMixins],
    components: {Multiselect},
    data() {
        return {
            itemFields: [
                {
                    key: 'id',
                    label: 'Actions',
                },

                {
                    key: 'sequence_no',
                    label: 'Sequence',
                },
                /*   {
                    key: 'previous_sequence_no',
                    label: 'Prev',
                }, */

                {
                    key: 'checkoff_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.checkoff_type.name,
                },
            ],
            model: {
                id: null,
                checkoff_type_id: null,
                sequence_no: null,
                previous_sequence_no: null,
                notify_users: [],
                notify_roles: [],
            },
            loading: false,
            itemModal: false,
            modelChanged: false,
            userOptions: [],
        }
    },

    computed: {
        componentName() { return this.$translate('review_template') },
        submitLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },

        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        types() {
            const items = this.$store.state.checkoffTypes.types
            console.log('items', items)
            return items
        },
        templateTypes() {
            const _templateTypes = (this.template && this.template.types) || []
            _templateTypes.sort((a, b) => a.sequence_no - b.sequence_no)
            return _templateTypes
        },
        notifyUsers(){
            let notifyUsers = this.$store.state.checkoffTypes.notify_users || []
            
            if(notifyUsers.length === 0) return []
            notifyUsers = notifyUsers && notifyUsers.checkoff_type_roles.map((item) => {
                return item.role.users.filter(x => x.user.is_customer_user == 0).map((x) => {
                    return {
                        id: x.user.id,
                        name: `${x.user.first_name}  ${x.user.last_name} (${item.role.name})`,
                        first_name: x.user.first_name,
                        last_name: x.user.last_name,
                    }
                })
            })

            return [].concat(...notifyUsers) // array flatten due to multiple roles user 
        },
        notifyUserRolesoptions(){
            let notifyRoles = this.$store.state.checkoffTypes.notify_users || []
            
            if(notifyRoles.length === 0) return []
            notifyRoles = notifyRoles && notifyRoles.checkoff_type_roles.map((item) => {
                return {
                    item: item.role.id, 
                    name: `All ${item.role.name} users`
                }
            })
            return notifyRoles
        },
    },
    watch: {},

    methods: {
        addType() {
            this.model = {
                id: null,
                previous_sequence_no: null,
                sequence_no: null,
                checkoff_type_id: null,
                notify_users: [],
                notify_roles: [],
            }
            this.itemModal = true
        },
        async viewType(id) {
            /* if the template exists find the item among the template's 
            types otherwise, firnd the item among the template model's types */
            const templateType =
                this.template.types.find(x => x.id === id) || {}
            this.model = { ...templateType }

            await this.setUsersForNotification(this.model.checkoff_type_id)
            this.model.notify_roles = this.model.notify_roles && this.model.notify_roles.map((item)=>{
                return item.id
            }) || []
            this.model.notify_users = this.model.notify_users && this.model.notify_users.map((item)=>{
                return {
                        id: item.id,
                        name: `${item.first_name}  ${item.last_name} (${item.roles[0].role.name})`,
                        first_name: item.first_name,
                        last_name: item.last_name,
                    }
            }) || []
            this.itemModal = true
            this.selectedRoles()
        },
        async deleteTemplateType() {
            // if the template exists delete the master item from the database

            const path = `checkoffTemplates/deleteType`
            const template_id = this.template.id
            const item_id = this.model.id
            const title = `${this.$translate('delete_process')}?`
            const message = `${this.$translate('delete_note')} process ?`

            const result = await this.confirmMessage(title, message)
            if (result) {
                try {
                    this.loading = true
                    await this.$store.dispatch(path, { template_id, item_id })
                    this.itemModal = false
                    this.modelChanged = false
                    this.doToast(
                        this.$translate('deleted'),
                        this.$translate('delete_process_alert'),
                        'success',
                    )
                } catch (error) {
                    console.log('error', error)
                    this.doToast(this.$translate('error'), error.message, 'danger')
                } finally {
                    this.loading = false
                }
            }
        },

        async saveTemplateType(bvModalEvt) {
            bvModalEvt.preventDefault()

            const item = { ...this.model }

            console.log('model item', item)

            item.previous_sequence_no = item.previous_sequence_no || 0
            const template_id = this.template.id
            const model = { template_id, item }

            // if the template exists add the master item to the template in the database or update it in the database
            const path = `checkoffTemplates/${parseInt(item.id) ? 'updateType' : 'createType'
                }`
            try {
                this.loading = true
                await this.$store.dispatch(path, model)
                if (parseInt(item.id)) {
                    this.doToast(this.$translate('updated'), `${this.$translate('review_process_update_alert')}`, 'Success')
                } else {
                    this.doToast(this.$translate('created'), `${this.$translate('review_process_create_alert')}`, 'Success')
                }
                this.loading = false
                this.itemModal = false
                this.modelChanged = false
            } catch (error) {
                console.log('error', error)
                let message = error.message
                this.doToast(this.$translate('error'), message, 'danger')
            } finally {
                this.loading = false
            }
        },
        async setUsersForNotification(type){
            if(type == null) return
            try {
                this.loading = true
                await this.$store.dispatch('checkoffTypes/getUsersByReviewType', type)
                this.userOptions = this.notifyUsers
                this.loading = false
            } catch (error) {
                console.log('error', error)
                let message = error.message
                this.doToast(this.$translate('error'), message, 'danger')
            } finally {
                this.loading = false
            }
        },
        cancel(){
            this.$store.commit('checkoffTypes/set_notify_users', [])
        },
        async selectedRoles() {
            this.userOptions.sort((a, b) => (`${a.first_name} ${a.last_name}` < `${b.first_name} ${b.last_name}`) ? -1 : (`${a.first_name} ${a.last_name}` > `${b.first_name} ${b.last_name}`) ? 1 : 0);
            var selected = this.userOptions.filter(s => this.model.notify_users.some(item => s.id == item.id))
            var notSelected = this.userOptions.filter(s => !this.model.notify_users.some(item => s.id == item.id))
            console.log('selected', selected)
            this.userOptions = [...selected, ...notSelected];
        }
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.multiselect__content-wrapper{
    position: static !important;
}
</style>